<div class="reservation-pay-dialog">
  <h2 class="dialog-title">Finalizar reserva</h2>

  <div class="total-row">
    <span class="total-label">Total a cobrar:</span>
    <span class="total-amount">{{ data.total | number: "1.2-2" }} €</span>
  </div>

  <!-- Selección de método de pago -->
  <div class="method-section" *ngIf="!paymentMethod || directPaying">
    <p class="section-label">Selecciona método de pago:</p>
    <div class="method-options">
      <div class="method-pill" [class.disabled]="loading" (click)="selectMethod('cash')">
        <i class="fa-light fa-coins"></i>
        <span>{{ loading && paymentMethod === 'cash' ? 'Procesando...' : (direct.cash ? 'Pagar con efectivo' : 'Pago en efectivo') }}</span>
      </div>
      <div class="method-pill" [class.disabled]="loading" (click)="selectMethod('tpv')">
        <i class="fa-light fa-credit-card"></i>
        <span>{{ loading && paymentMethod === 'tpv' ? 'Procesando...' : (direct.tpv ? 'Pagar con tarjeta' : 'Pago con tarjeta') }}</span>
      </div>
    </div>
    <p class="warning-info" *ngIf="directWarning">
      <i class="fa-light fa-triangle-exclamation"></i>
      {{ directWarning }}
    </p>
  </div>

  <!-- Efectivo -->
  <div class="cash-section" *ngIf="paymentMethod === 'cash' && !directPaying">
    <p class="section-label">
      <span class="method-back" (click)="paymentMethod = null">‹ Cambiar</span>
      Pago en efectivo
    </p>
    <p class="warning-info">
      <i class="fa-light fa-triangle-exclamation"></i>
      El método de pago no se podrá cambiar una vez realizado el pedido.
    </p>
    <div class="cash-field">
      <label>Importe recibido (€)</label>
      <input
        type="number"
        [(ngModel)]="cashAmount"
        min="0"
        [step]="0.01"
        placeholder="0.00"
        autofocus
      />
    </div>
    <div class="change-row" *ngIf="cashAmount != null">
      <span>Cambio a devolver:</span>
      <span class="change-amount" [class.negative]="!cashValid">
        {{ cashValid ? (change | number: "1.2-2") + " €" : "Importe insuficiente" }}
      </span>
    </div>
  </div>

  <!-- TPV -->
  <div class="tpv-section" *ngIf="paymentMethod === 'tpv' && !directPaying">
    <p class="section-label">
      <span class="method-back" (click)="paymentMethod = null">‹ Cambiar</span>
      Pago con tarjeta
    </p>
    <p class="tpv-info">
      <i class="fa-light fa-circle-info"></i>
      Pase la tarjeta por el terminal y confirme el cobro antes de hacer clic en 'pagar'.
    </p>
    <p class="warning-info">
      <i class="fa-light fa-triangle-exclamation"></i>
      El método de pago no se podrá cambiar una vez realizado el pedido.
    </p>
  </div>

  <!-- Error -->
  <p class="error-msg" *ngIf="errorMessage">
    <i class="fa-light fa-circle-xmark"></i> {{ errorMessage }}
  </p>

  <!-- Acciones -->
  <div class="dialog-actions" *ngIf="paymentMethod && !directPaying">
    <button class="btn-cancel" (click)="cancel()" [disabled]="loading">
      Cancelar
    </button>
    <button
      class="btn-confirm"
      (click)="confirm()"
      [disabled]="loading || (paymentMethod === 'cash' && !cashValid)"
    >
      <span *ngIf="!loading">Confirmar pago</span>
      <span *ngIf="loading">Procesando...</span>
    </button>
  </div>

  <div class="dialog-actions" *ngIf="!paymentMethod || directPaying">
    <button class="btn-cancel" (click)="cancel()" [disabled]="loading">Cancelar</button>
  </div>
</div>
